import { ObjectMesh } from "./ObjectMesh"

export default class FloorMesh extends ObjectMesh {

	
}